import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const API_URL = config.backendUrl

export const getAllAutoSaveWorkentries = createAsyncThunk(
    'autosave/getAllAutoSaveWorkentries',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/autosavework/getall`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { error: 'Unknown error' });
        }
    }
);

export const replaceAllWorkEntries = createAsyncThunk(
    'autosave/replaceAllWorkEntries',
    async ({ projectid, newEntries, tasktype, taskownerid }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${API_URL}/autosavework/save`, {
                projectid,
                newEntries,
                tasktype,
                taskownerid,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { error: 'Unknown error' });
        }
    }
);

const autoSaveWorkentriesSlice = createSlice({
    name: 'autosave',
    initialState: {
        loading: false,
        error: null,
        successMessage: null,
        autosaveentries: [], // <== Add this line

    },
    reducers: {
        clearAutoSaveStatus: (state) => {
            state.loading = false;
            state.error = null;
            state.successMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(replaceAllWorkEntries.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(replaceAllWorkEntries.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message;
            })
            .addCase(replaceAllWorkEntries.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Something went wrong';
            })

            .addCase(getAllAutoSaveWorkentries.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAutoSaveWorkentries.fulfilled, (state, action) => {
                state.loading = false;
                state.autosaveentries = action.payload;
            })

            .addCase(getAllAutoSaveWorkentries.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Something went wrong';
            })

    },
});

export const { clearAutoSaveStatus } = autoSaveWorkentriesSlice.actions;

export default autoSaveWorkentriesSlice.reducer;
